import { createContext, useContext, useEffect, useRef, useSyncExternalStore } from 'react';
import type { MissatgeTempsReal } from '@/api/types';
import type { EstatTempsReal, RealtimeClient } from './RealtimeClient';

export const RealtimeContext = createContext<RealtimeClient | null>(null);

export function useRealtimeClient(): RealtimeClient | null {
  return useContext(RealtimeContext);
}

export function useTopic<P = unknown>(
  topic: string | null | undefined,
  onMissatge: (missatge: MissatgeTempsReal<P>) => void,
): void {
  const client = useRealtimeClient();
  const ref = useRef(onMissatge);
  useEffect(() => {
    ref.current = onMissatge;
  });
  useEffect(() => {
    if (!client || !topic) return;
    return client.subscriu(topic, (m) => ref.current(m as MissatgeTempsReal<P>));
  }, [client, topic]);
}

const senseClient = () => () => undefined;

export function useRealtimeStatus(): EstatTempsReal {
  const client = useRealtimeClient();
  return useSyncExternalStore(
    client ? (cb) => client.onEstat(cb) : senseClient,
    () => client?.estat ?? 'desconnectat',
  );
}
